module.exports = __webpack_public_path__ + "media/images/about_logo-b260d1c2b053799e3088380adfd84ca4.png";